import React from 'react';
import {Link} from 'react-router-dom';

import {EvalSite} from 'src/lib/api/eval';

import SkillBadge from './SkillBadge';

export default function SiteCard({site, to}: {site: EvalSite; to: string}) {
  const kge = site.latestMetrics?.kge;
  const crps = site.latestMetrics?.crps;
  const crpss = undefined; // crpssLta removed: not computed by backend

  return (
    <Link
      to={to}
      className={`block rounded-md border border-gray-200 bg-white p-4 shadow-sm hover:border-gray-300`}
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="font-medium text-gray-900">{site.displayName || site.siteId}</div>
          <div className="text-xs text-gray-500">{site.siteId}</div>
        </div>
        <SkillBadge skill={crpss} />
      </div>

      <div className="mt-3 grid grid-cols-3 gap-3 text-sm">
        <Metric label="KGE" value={kge} />
        <Metric label="CRPS" value={crps} />
        <Metric label="CRPSS" value={crpss} />
      </div>
    </Link>
  );
}

function Metric({label, value}: {label: string; value: number | undefined}) {
  return (
    <div className="rounded bg-gray-50 p-2">
      <div className="text-xs text-gray-500">{label}</div>
      <div className="font-mono text-gray-900">{value === undefined ? '—' : value.toFixed(3)}</div>
    </div>
  );
}
